import { AlertTriangle, CheckCircle2, FileClock } from 'lucide-react';
import { useI18n } from '@/contexts/i18n-hook';
import type { ResumoDocumentosMaquina } from '@/lib/mock-documentos-maquina';

/**
 * Etiqueta com a situação documental de uma máquina, para caber numa célula de
 * tabela. Dados de protótipo — ver `@/lib/mock-documentos-maquina`.
 */
export function ResumoDocumentos({ resumo }: { resumo: ResumoDocumentosMaquina }) {
  const { t } = useI18n();
  const emAberto = resumo.pendentes + resumo.emAnalise;

  if (emAberto === 0) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold rounded-full whitespace-nowrap bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400">
        <CheckCircle2 className="h-3.5 w-3.5" />
        {t('documentos.resumoLinha.emDia')}
      </span>
    );
  }

  // Contagem em vez de frase: a coluna divide espaço com sete outras, e a frase
  // inteira empurrava a tabela para fora da largura da tela. O texto completo
  // continua acessível no `title`/`aria-label`.
  const rotuloPendentes = t('documentos.resumoLinha.pendentes', { total: emAberto });
  const rotuloAtrasados = t('documentos.resumoLinha.atrasados', { total: resumo.atrasados });

  return (
    <div className="flex items-center gap-1.5 whitespace-nowrap">
      <span
        title={rotuloPendentes}
        aria-label={rotuloPendentes}
        className="inline-flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded-full bg-schmersal-blue/10 dark:bg-schmersal-blue/25 text-schmersal-blue dark:text-schmersal-blue-light"
      >
        <FileClock className="h-3.5 w-3.5" />
        {emAberto}
      </span>
      {resumo.atrasados > 0 && (
        <span
          title={rotuloAtrasados}
          aria-label={rotuloAtrasados}
          className="inline-flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded-full bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400"
        >
          <AlertTriangle className="h-3.5 w-3.5" />
          {resumo.atrasados}
        </span>
      )}
    </div>
  );
}
